var map = {
	"./blessing_prize_1.png": "310c",
	"./blessing_prize_2.png": "35e0",
	"./blessing_prize_3.png": "049a",
	"./blessing_prize_4.png": "f2d4",
	"./blessing_prize_5.png": "5e8c",
	"./blessing_prize_6.png": "c363"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "385f";